import updateNewStagesCount from '../actions/updateNewStagesCount';

export default function stagesReducer(state = { newStagesCount: 0 }, action) {
    switch (action.type) {
        case updateNewStagesCount.type:
            return { newStagesCount: action.payload };
        default:
            return state;
    }
}
